import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  testId?: string;
  message?: string;
};

/** Canonical authenticated-shell state for every primary capability denial. */
export default function AppAccessDenied({
  testId = "access-denied",
  message = "You do not have permission to access this page."
}: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <Stack
      component="main"
      alignItems="center"
      justifyContent="center"
      minHeight="320px"
      spacing={1}
      data-testid={testId}
    >
      <Typography variant="h5">{t("Access denied")}</Typography>
      <Typography color="text.primary" textAlign="center">
        {t(message)}
      </Typography>
    </Stack>
  );
}
